import React, { useState, useEffect } from 'react'
import { parseISO, addHours } from 'date-fns'
import { format } from 'date-fns-tz'

import api from '../service/api'

import Navbar from '../components/navbar'

export default function Noticias() {

    const [noticias, setNoticias] = useState([])

    useEffect(() => {
        async function loadNoticias() {
            const response = await api.get('/open/noticias?sort=-data')
            setNoticias(response.data)
        }

        loadNoticias()
    }, [])

    function formatData(data) {
        const parsedDate = parseISO(data)
        const addedDate = addHours(parsedDate, 3)
        return format(addedDate, 'dd/MM/yyyy', {
            timeZone: 'America/Sao_Paulo',
        })
    }

    return (
        <div id="noticias">

            <Navbar bgColor='rgb(68,1,91)' />

            <div id="noticas-content" className="my-5 py-5" style={{ backgroundColor: "#eee" }}>
                {noticias.length > 0
                    ? noticias.map(noticia => (
                        <div key={noticia._id} className="card mb-3 w-75 mx-auto my-4">
                            <div className="row no-gutters">
                                <div className="col-md-4">
                                    <img src={api.defaults.baseURL + noticia.fotoUrl} className="card-img" alt="capa" />
                                </div>
                                <div className="col-md-8">
                                    <div className="card-body">
                                        <h5 id="titulo" className="pb-0  mb-0 card-title font-weight-bold display-4">{noticia.titulo}</h5>
                                        <span id="data" className="card-text text-muted my-0 py-0">Publicado em: {formatData(noticia.data)}</span>

                                        <p id="descricao" className="card-text mt-4">{noticia.descricao}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))
                    : <p className="text-center">Não há noticias cadastradas.</p>
                }
            </div>
        </div>
    )
}
